import * as React from 'react';
import { User } from '../../interfaces/User/User';

export const UserContext = React.createContext<null|undefined|User>(null);
